import { useEffect, useState } from 'react';

import { FLYWHEELS_CHANGED, listFlywheels } from '../api/flywheelsApi.js';
import { flywheelColor, flywheelIcon } from '../model/flywheelStyle.js';

const toNav = (f) => ({
    id: f.id, name: f.name, icon: flywheelIcon(f.icon), color: flywheelColor(f.color),
});

export default function useNavFlywheels(gameId) {
    const [flywheels, setFlywheels] = useState([]);

    useEffect(() => {
        if (!gameId) {
            setFlywheels([]);
            return undefined;
        }
        let alive = true;
        const load = () => listFlywheels(gameId)
            .then((list) => { if (alive) setFlywheels(list.map(toNav)); })
            .catch(() => { if (alive) setFlywheels([]); });
        const onChange = (e) => { if (!e.detail?.gameId || e.detail.gameId === gameId) load(); };
        load();
        window.addEventListener(FLYWHEELS_CHANGED, onChange);
        return () => {
            alive = false;
            window.removeEventListener(FLYWHEELS_CHANGED, onChange);
        };
    }, [gameId]);

    return flywheels;
}

// Ends hot updates here: the sidebar that uses this hook sits in the routes ↔ layout import cycle.
if (import.meta.hot) import.meta.hot.accept();
